import produce from 'immer';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { initialStates } from '../initial-states/initialStates';
import { DevicesState } from '../initial-states/stateTypes';

const initialState =
  process.env.REACT_APP_BYPASS_MODE === 'true'
    ? initialStates.devices.bypassState
    : initialStates.devices.normalState;

const reducer = produce(
  (state: DevicesState = initialState, action: Action) => {
    switch (action.type) {
      case ActionType.SET_LOGGER:
        state.logger = action.payload;
        return state;
      case ActionType.SET_SCANNER:
        state.scanner = action.payload;
        return state;
      case ActionType.SET_LOCKER:
        state.locker = action.payload;
        return state;
      case ActionType.UPDATE_SETTING_UP_SCANNERS:
        state.settingUpScanners = action.payload;
        return state;
      case ActionType.UPDATE_SETTING_UP_LOCKER:
        state.settingUpLocker = action.payload;
        return state;
      case ActionType.RESET_DEVICES:
        return initialState;
      default:
        return state;
    }
  },
  initialState
);

export default reducer;
